class Menus {
    constructor($) {
        this.$html = $('html');
        this.$body = $('body');
        this.$fullScreenBtn = $('.op3-fullscreenBtn');
        this.$fullScreenBtn
            .click((e) => {
                let _this = this;
                e.preventDefault();
                _this.$body.toggleClass('op3_isFullScreen');
                let isFullScreen = 0;
                if (_this.$body.hasClass('op3_isFullScreen')) {
                    isFullScreen = 1;
                }

                /**
                 * AJAX request that add option to WordPress for user full screen
                 *
                 * @see \FunnelBuilder\Service\Ajax\UserAjax::cloneFunnelPage
                 */
                $.post(
                    op3general.ajax_url,
                    {
                        'action': 'op3toggleFullScreen',
                        'isFullScreen': isFullScreen,
                    },
                    (response) => {
                        console.log('op3toggleFullScreen');
                        console.log(response);
                    }
                );
            })
        ;
    }
}

export default Menus;



// WEBPACK FOOTER //
// ./resources/assets/js/Menu/Menus.js